import { createContext, useContext } from "react";

export type User = {
  email: string;
  name: string;
  picture?: string;
  isAdmin: boolean;
};

export type AuthState = {
  user: User | null;
  loading: boolean;
  googleClientId: string | null;
  login: (googleToken: string) => Promise<void>;
  logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
